module.exports = "/assets/delivery/dpd.png?kYSyyw5";